import React, { useEffect } from 'react';
import useWindowSize from 'ksk/hooks/useWindowSize';

import acessoInformacao from 'ksk/assets/template/acesso_informacao.png';
import logoSerpro from 'ksk/assets/template/marca-serpro-2023/assinatura-serpro-govfederal-horiz-negativo-2025-01.png';
import logoMinisterioFazenda from 'ksk/assets/template/marca-serpro-2023/assinatura-serpro-govfederal-horiz-negativo-02.png';
import logoSerproVertical from 'ksk/assets/template/marca-serpro-2023/assinatura-serpro-govfederal-vert-negativo-2025-01.png';
import logoMinisterioFazendaVertical from 'ksk/assets/template/marca-serpro-2023/assinatura-serpro-govfederal-vert-negativo-02.png';
import logoTesouro from 'ksk/assets/template/tesouro-rodape.png';

import { S } from './MainFooter.styles';

function MainFooter() {
  useEffect(() => {
    if (window.core && window.core.BRFooter) {
      const brFooter = document.querySelector('.br-footer');
      new window.core.BRFooter('br-footer', brFooter);
    }
  }, []);
  
  const { isPhone, isTablet } =  useWindowSize();

  const ambiente = `${process.env.REACT_APP_AMBIENTE}`
  const dtPublicacao = `${process.env.REACT_APP_DTPUBLICACAO}`
  const idPipeline = `${process.env.REACT_APP_IDPIPELINE}`

  return (
    <S.Footer>
      <footer tabIndex="0" id="main-footer" className="br-footer">
          <div className="container-fluid">
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-center text-center text-md-start py-5">
              
              <div id="div1" className="mb-4 mb-md-0 flex-fill d-flex justify-content-center justify-content-md-start">
                <a href="https://www.gov.br/tesouronacional/" id="link-main-footer-tesouro-1" target="_blank">
                  <img alt="Logotipo do Tesouro Nacional" src={logoTesouro} />
                </a>
              </div>

              <div id="div2" className="mb-4 mb-md-0 flex-fill d-flex justify-content-center">
                {
                  isPhone || isTablet ? (
                    <div className="footer__stack-vertical">
                      <a href="https://www.serpro.gov.br/" id="link-main-footer-serpro" target="_blank">
                        <img alt="Logo do Serpro" src={logoSerproVertical} />
                      </a>
                      {/* <a href="https://www.gov.br/fazenda/" id="link-main-footer-ministerio" target="_blank">
                        <img alt="Logo do Ministério da Fazenda" src={logoMinisterioFazendaVertical} />
                      </a> */}
                    </div>
                  ) : (
                    <div className="footer__stack-horizontal d-flex gap-3">
                      <a href="https://serpro.gov.br/" id="link-main-footer-serpro" target="_blank">
                        <img className="footer__serpro__logo" alt="Logo do Serpro" src={logoSerpro} />
                      </a>
                      {/* <a href="https://www.gov.br/fazenda/" id="link-main-footer-ministerio" target="_blank">
                        <img className="footer__serpro__logo" alt="Logo do Ministério da Fazenda" src={logoMinisterioFazenda} />
                      </a> */}
                    </div>
                  )
                }
              </div>

              <div id="div3" className="flex-fill d-flex justify-content-center justify-content-md-end">
                <a href="https://www.gov.br/acessoainformacao/pt-br" id="link-main-footer-acesso-informacao" target="_blank">
                  <img alt="Logo do portal de acesso à informação" src={acessoInformacao} />
                </a>
              </div>
              
            </div>
          </div>
          <span className="br-divider my-3"></span>
          <div className="info">
              <div className="text-down-01 pb-3">
                <div className="display-none">{ ambiente }</div>
                <div>Versão 1.19.4/{ idPipeline } - { dtPublicacao }</div>
              </div>
          </div>
      </footer>
    </S.Footer>
  )
}

export default MainFooter;
